import { Button, CircularProgress } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";

const styles = (theme) => ({
  ctaBtn: {
    height: "55px",
    width: "217px",
    borderRadius: "27.5px",
    "&:hover": {
      border: `1px solid ${theme.palette.auth.cta}`,
      color: "#ffffff",
      backgroundColor: theme.palette.auth.cta,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent",
      },
    },
    transition: theme.transitions.create(
      ["background-color", "box-shadow", "border", "color"],
      {
        duration: theme.transitions.duration.short,
      }
    ),
  },
});

const FormButton = ({ label, loader, classes, disabled = false }) => {
  return (
    <>
      {loader ? (
        <CircularProgress />
      ) : (
        <Button
          variant="outlined"
          color="primary"
          type="submit"
          className={classes.ctaBtn}
          disabled={disabled}
        >
          {label}
        </Button>
      )}
    </>
  );
};

export default withStyles(styles)(FormButton);
